import vecchi from "./messages.js";
import { conRipiegoSulVecchio, costruisciMessaggi, type MessaggiPerLingua } from "./registro";

// Solo i nuovi file JSON (senza il vecchio): serve ai test e allo script di migrazione.
export const messaggiNuovi: MessaggiPerLingua = costruisciMessaggi(
  import.meta.glob("./locales/*/*.json", { eager: true, import: "default" }),
);

// Quello che usa l'app: nuovo con ripiego sul vecchio `messages.js` (da eliminare a fine fase).
export const messaggi: MessaggiPerLingua = conRipiegoSulVecchio(messaggiNuovi, vecchi as unknown as MessaggiPerLingua);
